document.addEventListener('DOMContentLoaded', () => {
  const form = document.querySelector('[data-quote-form]');
  const startInput = document.querySelector('[data-rental-start]');
  const endInput = document.querySelector('[data-rental-end]');
  const submitButton = form?.querySelector('.quote-submit, button[type="submit"]');
  if (!form || !startInput || !endInput || !submitButton) return;

  let error = document.querySelector('[data-required-dates-error]');
  if (!error) {
    error = document.createElement('div');
    error.setAttribute('data-required-dates-error', '');
    error.className = 'required-dates-error';
    error.textContent = 'Te rog completează câmpurile obligatorii.';
    error.hidden = true;
    submitButton.insertAdjacentElement('beforebegin', error);
  }

  function datesComplete() {
    return Boolean(startInput.value && endInput.value);
  }

  function updateSubmitState() {
    const ok = datesComplete();
    submitButton.disabled = !ok;
    submitButton.classList.toggle('is-disabled', !ok);
    if (ok) error.hidden = true;
  }

  [startInput, endInput].forEach((input) => {
    input.addEventListener('input', updateSubmitState);
    input.addEventListener('change', updateSubmitState);
  });

  form.addEventListener('submit', (event) => {
    if (!datesComplete()) {
      event.preventDefault();
      event.stopImmediatePropagation();
      error.hidden = false;
      error.textContent = 'Te rog completează câmpurile obligatorii.';
      error.scrollIntoView({ behavior: 'smooth', block: 'center' });
      updateSubmitState();
    }
  }, true);

  updateSubmitState();
});
